/* GENERATED FROM intentMgr.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import {
  APIRequest,
  APIResponse,
  makeRequest,
  preProcessingResponse
} from '../'
import * as base from './base.service'
import * as changeMgr from './changeMgr.service'
import * as commonHdr from './commonHdr.service'

export class IntentMgr {
  static CreateMonitor = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<CreateMonitorReq, {}, CreateMonitorResp>): Promise<
    APIResponse<CreateMonitorResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/monitors`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<CreateMonitorResp>>()
          .then<APIResponse<CreateMonitorResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetMonitor = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetMonitorReq, {}, GetMonitorResp>): Promise<
    APIResponse<GetMonitorResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/monitors`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetMonitorResp>>()
          .then<APIResponse<GetMonitorResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UpdateMonitor = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UpdateMonitorReq, {}, UpdateMonitorResp>): Promise<
    APIResponse<UpdateMonitorResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/monitors`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UpdateMonitorResp>>()
          .then<APIResponse<UpdateMonitorResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetMonitorCount = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetMonitorsCountReq, {}, GetMonitorsCountResp>): Promise<
    APIResponse<GetMonitorsCountResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/monitorscount`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetMonitorsCountResp>>()
          .then<APIResponse<GetMonitorsCountResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static DeleteMonitor = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<DeleteMonitorReq, {}, DeleteMonitorResp>): Promise<
    APIResponse<DeleteMonitorResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/monitors`,
      method: 'DELETE',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<DeleteMonitorResp>>()
          .then<APIResponse<DeleteMonitorResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static CreateAlert = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<CreateAlertReq, {}, CreateAlertResp>): Promise<
    APIResponse<CreateAlertResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/alerts`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<CreateAlertResp>>()
          .then<APIResponse<CreateAlertResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetAlert = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetAlertsReq, {}, GetAlertsResp>): Promise<
    APIResponse<GetAlertsResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/alerts`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetAlertsResp>>()
          .then<APIResponse<GetAlertsResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetAlertNew = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetAlertsReq, {}, GetAlertsResp>): Promise<
    APIResponse<GetAlertsResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/alertsv2`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetAlertsResp>>()
          .then<APIResponse<GetAlertsResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetAlertCount = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetAlertsCountReq, {}, GetAlertsCountResp>): Promise<
    APIResponse<GetAlertsCountResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/alertscount`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetAlertsCountResp>>()
          .then<APIResponse<GetAlertsCountResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UpdateAlert = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UpdateAlertReq, {}, UpdateAlertResp>): Promise<
    APIResponse<UpdateAlertResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/alerts`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UpdateAlertResp>>()
          .then<APIResponse<UpdateAlertResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static DeleteAlert = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<DeleteAlertReq, {}, DeleteAlertResp>): Promise<
    APIResponse<DeleteAlertResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/alerts`,
      method: 'DELETE',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<DeleteAlertResp>>()
          .then<APIResponse<DeleteAlertResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetSuites = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetSuitesReq, {}, GetSuitesResp>): Promise<
    APIResponse<GetSuitesResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/suites`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetSuitesResp>>()
          .then<APIResponse<GetSuitesResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetRules = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetRulesReq, {}, GetRulesResp>): Promise<
    APIResponse<GetRulesResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/rules`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetRulesResp>>()
          .then<APIResponse<GetRulesResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetComplianceRules = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetComplianceRulesReq, {}, GetComplianceRulesResp>): Promise<
    APIResponse<GetComplianceRulesResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/complianceRules`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetComplianceRulesResp>>()
          .then<APIResponse<GetComplianceRulesResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetRule = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetRuleReq, {}, GetRuleResp>): Promise<
    APIResponse<GetRuleResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/rule`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetRuleResp>>()
          .then<APIResponse<GetRuleResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static DismissAlert = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<MultiAlertActionReq, {}, MultiAlertActionResp>): Promise<
    APIResponse<MultiAlertActionResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/dismissAlert`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<MultiAlertActionResp>>()
          .then<APIResponse<MultiAlertActionResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static KeepAlert = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<MultiAlertActionReq, {}, MultiAlertActionResp>): Promise<
    APIResponse<MultiAlertActionResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/keepAlert`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<MultiAlertActionResp>>()
          .then<APIResponse<MultiAlertActionResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetFailedCountsByRegion = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<
    GetFailedCountsByRegionReq,
    {},
    GetFailedCountsByRegionResp
  >): Promise<APIResponse<GetFailedCountsByRegionResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/failedCountsByRegion`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetFailedCountsByRegionResp>>()
          .then<APIResponse<GetFailedCountsByRegionResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static RemediateAlert = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<MultiAlertActionReq, {}, MultiAlertActionResp>): Promise<
    APIResponse<MultiAlertActionResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/intents/remediateAlert`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<MultiAlertActionResp>>()
          .then<APIResponse<MultiAlertActionResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
}

export interface ProcessMonitorInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  name?: string
  severity?: commonHdr.AlertSeverityEnum
  query?: string
  user_id?: string
  label?: string
  monitor_id?: string
  auto_create?: boolean
  ignore_first_alerts?: boolean
  first_run?: boolean
  alerts_enabled?: boolean
  description?: string
  auto_intent_id?: string
  suppression_delete?: commonHdr.SuppressionTypeEnum
  suppression_create?: commonHdr.SuppressionTypeEnum
}

export interface ProcessMonitorResp {
  resp_hdr?: base.RespHdr
}

export interface AlertSuppressObject {
  alert_time?: string
  name?: string
  object_uri?: string
  monitor_id?: string
}

export interface MonitorInfo {
  tenant_id?: string
  monitor_id?: string
  name?: string
  severity?: commonHdr.AlertSeverityEnum
  label?: string
  user_id?: string
  alert_count?: number
  create_date?: string
  last_alert_date?: string
  result_set?: string
  status?: MonitorStatusEnum
  query?: string
  alerts_enabled?: boolean
  auto_create?: boolean
  ignore_first_alerts?: boolean
  first_run?: boolean
  description?: string
  result_table?: commonHdr.SearchResultTableRow[]
  suppression_delete?: commonHdr.SuppressionTypeEnum
  suppression_create?: commonHdr.SuppressionTypeEnum
  graph_based?: boolean
  auto_intent_id?: string
  passed_count?: number
  failed_count?: number
  remediation?: string
  category_id?: number
  audit?: string
  remediate?: boolean
  last_status_change_date?: string
}

export interface GetMonitorReq {
  req_hdr?: base.ReqHdr
  monitor_id?: string
}

export interface GetMonitorInternalReq {
  get_monitor?: GetMonitorReq
  tenant_id?: string
  skip_graph?: boolean
}

export interface GetMonitorResp {
  resp_hdr?: base.RespHdr
  monitor_info_list?: MonitorInfo[]
}

export interface DeleteMonitorReq {
  req_hdr?: base.ReqHdr
  monitor_id?: string
}

export interface DeleteMonitorResp {
  resp_hdr?: base.RespHdr
}

export interface CreateMonitorReq {
  req_hdr?: base.ReqHdr
  name?: string
  severity?: commonHdr.AlertSeverityEnum
  query?: string
  user_id?: string
  label?: string
  ignore_first_alerts?: boolean
  description?: string
  suppression_delete?: commonHdr.SuppressionTypeEnum
  suppression_create?: commonHdr.SuppressionTypeEnum
  short_name?: string
}

export interface CreateMonitorResp {
  resp_hdr?: base.RespHdr
  monitor_info?: MonitorInfo
}

export interface GetMonitorsCountReq {
  req_hdr?: base.ReqHdr
}

export interface GetMonitorsCountResp {
  resp_hdr?: base.RespHdr
  total_count?: number
  active_count?: number
}

export interface CreateAutoMonitorReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface CreateAutoMonitorResp {
  resp_hdr?: base.RespHdr
}

export interface UpdateMonitorReq {
  req_hdr?: base.ReqHdr
  monitor_id?: string
  name?: string
  severity?: commonHdr.AlertSeverityEnum
  query?: string
  user_id?: string
  label?: string
  result_set?: string
  alert_count?: number
  last_alert_date?: string
  alerts_enabled?: boolean
  first_run?: boolean
  description?: string
  result_table?: commonHdr.SearchResultTableRow[]
  suppression_delete?: commonHdr.SuppressionTypeEnum
  suppression_create?: commonHdr.SuppressionTypeEnum
  failed_count?: number
  passed_count?: number
  monitor_ids?: string[]
  short_name?: string
  last_status_change_date?: string
}

export interface UpdateMonitorInternalReq {
  update_monitor?: UpdateMonitorReq
  tenant_id?: string
  external_request?: boolean
}

export interface UpdateMonitorResp {
  resp_hdr?: base.RespHdr
  monitor_info?: MonitorInfo
}

export interface AlertsInfo {
  tenant_id?: string
  alert_id?: string
  entity_type?: string[]
  status?: commonHdr.AlertStatusEnum
  severity?: commonHdr.AlertSeverityEnum
  monitor_description?: string
  monitor_query?: string
  monitor_name?: string
  monitor_id?: string
  user_id?: string
  alert_time?: string
  snapshot_id?: string
  node_id_list?: string[]
  edge_id_list?: string[]
  object_count?: number
  result_graph?: string
  change_info?: changeMgr.ChangeInfo[]
  object_details_list?: commonHdr.ObjectDetails[]
  chart?: string
  alert_type?: AlertTypeEnum
  alert_query?: string
  start_time?: string
  end_time?: string
  object_uri?: string
  region?: string
  object_name?: string
  context?: string
  account_id?: string
  dismissed_time?: string
}

export interface SeverityCountInfo {
  severity?: commonHdr.AlertSeverityEnum
  count?: number
}

export interface CreateAlertInternalReq {
  data?: CreateAlertReq
  tenant_id?: string
}

export interface CreateAlertReq {
  req_hdr?: base.ReqHdr
  status?: commonHdr.AlertStatusEnum
  type?: string[]
  description?: string
  user_id?: string
  monitor_id?: string
  object_details_list?: commonHdr.ObjectDetails[]
  severity?: commonHdr.AlertSeverityEnum
  monitor_name?: string
  monitor_query?: string
  result_graph?: string
  object_count?: number
  edge_id_list?: string[]
  privilege_alert?: boolean
  chart?: string
  alert_type?: AlertTypeEnum
  alert_query?: string
  start_time?: string
  end_time?: string
  object_uri?: string
  object_name?: string
  context?: string
  skip_changes?: boolean
  alert_time?: string
}

export interface CreateAlertResp {
  resp_hdr?: base.RespHdr
}

export interface GetAlertsReq {
  req_hdr?: base.ReqHdr
  alert_type?: AlertTypeEnum
  alert_id?: string
  rsrc_type?: commonHdr.ResourceTypeEnum
  rsrc_name?: string
  account_id?: string
  alert_status?: commonHdr.AlertStatusEnum[]
  table_options?: commonHdr.ServerTableReq
  severity?: commonHdr.AlertSeverityEnum
  change_id?: string
  entity_type?: string
}

export interface AlertCountResp {
  total_count?: number
  open_count?: number
  high_count?: number
  medium_count?: number
  low_count?: number
}

export interface AlertTypeCount {
  alert_type?: string
  high_count?: number
  total_count?: number
}

export interface GetAlertsResp {
  resp_hdr?: base.RespHdr
  alert_count_list?: commonHdr.CommonTypeCount[]
  alert_info_list?: AlertsInfo[]
  pages_count?: number
  count?: AlertCountResp
  type_count_list?: AlertTypeCount[]
}

export interface GetAlertInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  alert_id?: string
}

export interface GetAlertInternalResp {
  resp_hdr?: base.RespHdr
  alert_info?: AlertsInfo
}

export interface GetAlertsCountReq {
  req_hdr?: base.ReqHdr
  for_days?: number
  account_id?: string
}

export interface GetAlertsCountResp {
  resp_hdr?: base.RespHdr
  low_count?: number
  medium_count?: number
  high_count?: number
}

export interface GenerateAlertSummaryInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface GenerateAlertSummaryInternalResp {
  resp_hdr?: base.RespHdr
}

export interface UpdateAlertInfo {
  alert_id?: string
  status?: commonHdr.AlertStatusEnum
  user_id?: string
}

export interface UpdateAlertReq {
  req_hdr?: base.ReqHdr
  update_alert_info_list?: UpdateAlertInfo[]
}

export interface UpdateAlertInternalReq {
  req?: UpdateAlertReq
  tenant_id?: string
}

export interface UpdateAlertResp {
  resp_hdr?: base.RespHdr
  alert_info_list?: AlertsInfo[]
}

export interface DeleteAlertReq {
  req_hdr?: base.ReqHdr
  alert_id?: string
}

export interface DeleteAlertResp {
  resp_hdr?: base.RespHdr
}

export interface GetSuitesReq {
  req_hdr?: base.ReqHdr
}

export interface GetSuitesResp {
  resp_hdr?: base.RespHdr
  suites?: GroupRuleInfo[]
  total_tests?: number
  failing_tests?: number
  passing_tests?: number
}

export interface GetComplianceRulesReq {
  req_hdr?: base.ReqHdr
  suite_id?: number
}

export interface GetComplianceRulesResp {
  resp_hdr?: base.RespHdr
  rules?: GroupRuleInfo[]
  total_tests?: number
  failing_tests?: number
  passing_tests?: number
  suite?: string
}

export interface GetRulesReq {
  req_hdr?: base.ReqHdr
  region?: string
  object_uri?: string
}

export interface GetRulesResp {
  resp_hdr?: base.RespHdr
  rules?: GroupRuleInfo[]
  total_tests?: number
  failing_tests?: number
  passing_tests?: number
}

export interface GetRuleReq {
  req_hdr?: base.ReqHdr
  rule_id?: string
  region?: string
  show_dismissed?: boolean
  show_open_only?: boolean
  object_uri?: string
}

export interface GetRuleResp {
  resp_hdr?: base.RespHdr
  failed_objects?: FailedObjectInfo[]
  rule_details?: RuleInfo
}

export interface MultiAlertActionReq {
  req_hdr?: base.ReqHdr
  items?: AlertActionReq[]
  monitor_id?: string
}

export interface AlertActionReq {
  alert_id?: string
  object_uri?: string
  name?: string
  time?: string
}

export interface MultiAlertActionResp {
  resp_hdr?: base.RespHdr
}

export interface SuiteCreateReportReq {
  req_hdr?: base.ReqHdr
  suite_id?: number
}

export interface GroupRuleInfo {
  id?: string
  name?: string
  severity?: commonHdr.AlertSeverityEnum
  alert_type?: AlertTypeEnum
  tests_count?: number
  passed_count?: number
  failed_count?: number
  last_status_change?: string
  category?: string
  last_alert_date?: string
}

export interface FailedObjectInfo {
  alert_id?: string
  name?: string
  account_id?: string
  region?: string
  time?: string
  object_uri?: string
  monitor_id?: string
  cloud_resource_name?: string
  type?: string
  severity?: commonHdr.AlertSeverityEnum
  alert_type?: AlertTypeEnum
  alert_query?: string
  start_time?: string
  end_time?: string
  dismissed?: boolean
  dismissed_time?: string
  context?: string
}

export interface RuleInfo {
  name?: string
  description?: string
  remediation?: string
  audit?: string
  remediate?: boolean
  category?: string
  query?: string
}

export interface GetFailedCountsByRegionReq {
  req_hdr?: base.ReqHdr
}

export interface GetFailedCountsByRegionResp {
  resp_hdr?: base.RespHdr
  counts?: FailedCountsByRegion[]
}

export interface FailedCountsByRegion {
  region_info?: RegionInfo
  count?: number
}

export interface RegionInfo {
  code?: string
  name?: string
  coordinates?: commonHdr.coordinates
}

export enum MonitorStatusEnum {
  MONITOR_NONE = 'MONITOR_NONE',
  MONITOR_NEW = 'MONITOR_NEW',
  MONITOR_RUN = 'MONITOR_RUN',
  MONITOR_DELETE = 'MONITOR_DELETE'
}

export enum AlertTypeEnum {
  ALERT_TYPE_NONE = 'ALERT_TYPE_NONE',
  ALERT_TYPE_GUARDRAIL = 'ALERT_TYPE_GUARDRAIL',
  ALERT_TYPE_AI = 'ALERT_TYPE_AI',
  ALERT_TYPE_USAGE = 'ALERT_TYPE_USAGE',
  ALERT_TYPE_LOCATION = 'ALERT_TYPE_LOCATION',
  ALERT_TYPE_EVENT = 'ALERT_TYPE_EVENT'
}
